"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationValues = exports.EMessageStorageBillingProfitStatus = exports.EMessageStoragePayloadFileType = exports.EMessageStoragePayloadButtonActions = void 0;
var EMessageStoragePayloadButtonActions;
(function (EMessageStoragePayloadButtonActions) {
    EMessageStoragePayloadButtonActions["url"] = "url";
    EMessageStoragePayloadButtonActions["legacyAction"] = "legacyAction";
})(EMessageStoragePayloadButtonActions || (exports.EMessageStoragePayloadButtonActions = EMessageStoragePayloadButtonActions = {}));
var EMessageStoragePayloadFileType;
(function (EMessageStoragePayloadFileType) {
    EMessageStoragePayloadFileType["image"] = "image";
    EMessageStoragePayloadFileType["audio"] = "audio";
    EMessageStoragePayloadFileType["file"] = "file";
})(EMessageStoragePayloadFileType || (exports.EMessageStoragePayloadFileType = EMessageStoragePayloadFileType = {}));
var EMessageStorageBillingProfitStatus;
(function (EMessageStorageBillingProfitStatus) {
    EMessageStorageBillingProfitStatus["profitable"] = "profitable";
    EMessageStorageBillingProfitStatus["unprofitable"] = "unprofitable";
    EMessageStorageBillingProfitStatus["neutral"] = "neutral";
})(EMessageStorageBillingProfitStatus || (exports.EMessageStorageBillingProfitStatus = EMessageStorageBillingProfitStatus = {}));
var ModerationValues;
(function (ModerationValues) {
    ModerationValues["approved"] = "approved";
    ModerationValues["rejected"] = "rejected";
    ModerationValues["pending"] = "pending";
})(ModerationValues || (exports.ModerationValues = ModerationValues = {}));
//# sourceMappingURL=message-storage.enum.js.map